import { ExportEnumFileType } from '@/domain/ExportEnumFileType';
import { ExportEnumFormat } from '@/domain/ExportEnumFormat';
import { Projeksjon, toSrid } from '@/domain/Projeksjon';
import { ExportQueries } from '@/middleware/queries/ExportQueries';
import { DatakatalogMode } from '@/components/avgrensning/datakatalog/constants';
import { MapLayerType } from '@/components/map/map-utils/WebMapTileServices';

export const PREFERENCES_STORAGE_KEY = 'preferences';
export const API_VERSION_STORAGE_KEY = 'apiVersion';
export const API_ENVIRONMENT_STORAGE_KEY = 'apiEnvironment';

export class PreferencesState {
    constructor(
        readonly includeTrafikantgruppe: boolean = true,
        readonly transformTinyGeometries: boolean = false,
        readonly disableClusters: boolean = true,
        readonly showGeometryInfo: boolean = false,
        readonly showMetadata: boolean = false,
        readonly showPropertyBoundaries: boolean = false,
        readonly fetchStatisticsLength: boolean = false,
        readonly exportProjection: Projeksjon = Projeksjon.UTM_33,
        readonly exportEnumFormat: ExportEnumFormat = ExportEnumFormat.StandardID,
        readonly exportEnumFileType: ExportEnumFileType = ExportEnumFileType.csv,
        readonly datakatalogDefaultMode: DatakatalogMode = DatakatalogMode.BIG,
        readonly mapLayer: MapLayerType = MapLayerType.STANDARD,
        readonly useEgengeometriWhenAvailable: boolean = true,
        readonly showDeveloperSettings: boolean = false,
        readonly includeTopoWithStandardMap: boolean = true
    ) {}

    override(modifyObject: {
        [P in keyof PreferencesState]?: PreferencesState[P];
    }): PreferencesState {
        return Object.assign(Object.create(PreferencesState.prototype), {
            ...this,
            ...modifyObject,
        });
    }

    toExportQueries() {
        const srid = toSrid(this.exportProjection).toString();
        return new ExportQueries(srid);
    }
}

export enum ApiVersion {
    V3 = 'v3',
    V4 = 'v4',
}

export type ApiEnvironment =
    | 'localhost'
    | 'localhosteksport'
    | 'local'
    | 'stm'
    | 'dev'
    | 'test'
    | 'prod'
    | 'elvegutv'
    | 'elvegtest'
    | 'elvegprod';
